(function () {
  if (customElements.get('ce-video') !== undefined) {
    return;
  }

  class Video extends HTMLParsedElement {
    constructor() {
      super();

      this.selectors = {
        target: '[data-video-target]',
      };

      this.elements = null;
      this.intersectionObserver = null;
      this.plyr = null;
    }

    parsedCallback() {
      this.elements = {
        target: this.querySelector(this.selectors.target),
      };

      const callback = (entries) => {
        for (let entry of entries) {
          if (entry.isIntersecting) {
            this.plyr = new Plyr(this.elements.target, {
              controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'pip', 'airplay', 'fullscreen'],
              invertTime: false,
            });

            this.intersectionObserver.unobserve(this);
          }
        }
      };

      const options = {
        rootMargin: '0px 0px 1400px 0px',
      };

      this.intersectionObserver = new IntersectionObserver(callback, options);
      this.intersectionObserver.observe(this);
    }

    disconnectedCallback() {
      this.plyr.destroy();
      this.intersectionObserver.disconnect();
    }
  }

  customElements.define('ce-video', Video);
})();
